import { Tables } from "@/gen/tableNames/tables";
import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";
import { createEnum } from "@/lib/utils/createEnum";

export type C5Issuer = {
  id: number;
  name: string;
  country: string;
  country_name: string;
  sector: string;
  created_at: string;
  updated_at: string;
};
export const c5IssuerFields = createEnum<C5Issuer>();

const tableName = Tables.C5_ISSUERS;
const t = (key: string, defaultValue: string) =>
  i18n.t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });

export const issuers_columns: ColumnDef<C5Issuer>[] = [
  {
    accessorKey: c5IssuerFields.id,
    header: t("id", "ID"),
  },
  {
    accessorKey: c5IssuerFields.name,
    header: t("name", "Name"),
  },
  {
    accessorKey: c5IssuerFields.country_name,
    header: t("country_name", "Country"),
  },
  {
    accessorKey: c5IssuerFields.sector,
    header: t("sector", "Sector"),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex gap-3 justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue(c5IssuerFields.id)}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
